import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'

import DocumentationOverviewScreen from '../screens/documentation/DocumentationOverviewScreen'
import commonStackNavigatorScreens from './commonStackNavigatorScreens'
import { commonScreenOptions } from '../config/navigation'

const Stack = createStackNavigator()

const DocumentationNavigator = () => {
  return (
    <Stack.Navigator
      initialRouteName="Documentation"
      screenOptions={{ ...commonScreenOptions }}
    >
      <Stack.Screen
        name="Documentation"
        component={DocumentationOverviewScreen}
        options={{ headerShown: false }}
      />

      {commonStackNavigatorScreens.map(
        ({ name, component, options, title }) => (
          <Stack.Screen
            name={name}
            title={title}
            component={component}
            options={options}
            key={name}
          />
        )
      )}
    </Stack.Navigator>
  )
}

export default DocumentationNavigator
